import React from 'react';
import {
  Switch,
  Route,
} from 'react-router-dom';
import LoginPage from 'pages/LoginPage';
import RegisterPage from 'pages/RegisterPage';
import {pathnames as P} from 'common/constants/pathnames';

export const routes = [
  {
    path: P.AUTH_LOGIN,
    exact: false,
    component: LoginPage
  },
  {
    path: P.AUTH_REGISTER,
    exact: false,
    component: RegisterPage
  },
];

const Auth = () => (
    <Switch>
      {routes.map((route, ind) => <Route key={ind} {...route}/>)}
    </Switch>
);

export default Auth;

